<template>
  <div id="app">
    <div class="globalLoading" v-show="is_loading">
      <span>
        <img src="./assets/img/loading.gif">
      </span>
    </div>
    <router-view :title="title"></router-view>
  </div>
</template>

<script>
import store from './store/index'
import { mapActions, mapGetters } from 'vuex'
import { showTips, postCnzzData } from './assets/js/util.js'

export default {
  name: 'app',
  store: store,
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'need_jump_login',
      'is_login',
      'enterprise_id'
    ]),
    title () {
      return this.$route.meta ? this.$route.meta.title : ''
    },
    keep_alive () {
      return this.$route.meta ? this.$route.meta.keep_alive : ''
    },
    is_loading () {
      return this.$store.state.common.is_loading
    }
  },
  methods: {
    ...mapActions([
      'getOpenCity',
      'setWinHeight',
      'postAnalyzeData'
    ]),
    resize () {
      var _self = this
      if (window) {
        window.onresize = function () {
          _self.setWinHeight(window.innerHeight)
        }
      }
    }
  },
  watch: {
    need_jump_login (val) {
      if (val) {
        var _self = this
        showTips(_self.is_login ? '登录失效，请重新登录' : '请先登录')
        var path = '/login?from=' + encodeURIComponent(_self.$route.fullPath)
        if (_self.enterprise_id) {
          path = '/e/' + _self.enterprise_id + path
        }
        _self.$router.push({
          path: path
        })
      }
    },
    '$route' () {
      var _self = this
      postCnzzData('9.0 页面访问', _self.title || '统计')
      if (_self.enterprise_id) {
        _self.postAnalyzeData({
          category: '页面访问',
          action: _self.enterprise_id || 'id',
          opt_label: _self.title || '首页'
        })
      }
    }
  },
  created () {
    var _self = this
    if (_self.enterprise_id) {
      _self.getOpenCity() // 获取开放城市
      // 百度统计
      _self.postAnalyzeData({
        category: '企业访问',
        action: _self.enterprise_id || 'id'
      })
    }
    _self.resize()
  },
  updated () {
  }
}
</script>

<style lang="scss">
  .globalLoading {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    span {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 41px;
      margin: -21px 0 0 -21px;
      img {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?227d0ebc